// Ref-counted body-scroll lock zodat meerdere overlays (FiltersPanel,
// ConfirmModal, ...) elkaars lock niet ophefen.
import { useEffect } from "react";

let locks = 0;
let previousOverflow = null;

export const lockBodyScroll = () => {
  if (locks === 0) {
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
  }
  locks += 1;
};

export const unlockBodyScroll = () => {
  if (locks === 0) return;
  locks -= 1;
  if (locks === 0) {
    document.body.style.overflow = previousOverflow ?? "";
    previousOverflow = null;
  }
};

// React hook-wrapper: lockt zolang `active` truthy is en unlockt netjes bij
// unmount of als `active` weer false wordt. Ref-count houdt overlays die
// elkaar overlappen veilig.
export const useBodyScrollLock = (active) => {
  useEffect(() => {
    if (!active) return undefined;
    lockBodyScroll();
    return () => unlockBodyScroll();
  }, [active]);
};
